import type { ReactNode } from 'react';
import { CrossIcon } from '../icons';
import styles from './ui.module.css';

/**
 * Пронумерованная запись внутри поля формы: стартовая способность анкеты.
 *
 * Одна рамка на запись, номер в квадрате слева, крестик справа. Пока это были
 * два независимых `FormItem` с подписями «Способность 1» и «Как работает»,
 * читателю приходилось догадываться, что они про одно и то же, — а на двух
 * записях подряд подписи повторялись четыре раза и занимали больше места, чем
 * сами значения.
 */
export function FormEntry({
  number,
  head,
  removeLabel,
  onRemove,
  children,
}: {
  number: number;
  /** Шапка записи: поле её названия. */
  head: ReactNode;
  removeLabel: string;
  onRemove: () => void;
  children: ReactNode;
}) {
  return (
    <div className={styles.formEntry}>
      <span className={styles.formEntryNo}>{number}</span>
      <span className={styles.formEntryTitle}>{head}</span>
      <button
        type="button"
        className={styles.formEntryRemove}
        aria-label={removeLabel}
        onClick={onRemove}
      >
        <CrossIcon size={10} />
      </button>
      {/* Второй ряд сетки, столбец названия: коробки совпадают краями. */}
      <div className={styles.formEntryBody}>{children}</div>
    </div>
  );
}

/** Колонка записей с шагом в восемь пикселей — как в макете. */
export function FormEntryList({ children }: { children: ReactNode }) {
  return <div className={styles.formEntryList}>{children}</div>;
}

/**
 * Полоса «завести ещё»: кнопка и предел рядом с ней.
 *
 * Предел стоит ЗДЕСЬ, а не над списком: он объясняет, почему кнопка погасла, и
 * читать его надо в тот момент, когда тянешься нажать.
 */
export function FormEntryAdd({ children }: { children: ReactNode }) {
  return <div className={styles.formEntryAdd}>{children}</div>;
}
